import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FaqSection = () => {
  const [expandedFaqs, setExpandedFaqs] = useState([]);

  const toggleFaq = (index) => {
    if (expandedFaqs.includes(index)) {
      setExpandedFaqs(expandedFaqs.filter(i => i !== index));
    } else {
      setExpandedFaqs([...expandedFaqs, index]);
    }
  };

  const faqs = [
    {
      question: "What is the current funding round amount and structure?",
      answer: "We are currently raising £10 million in Series A funding. This round will support our next two years of development, regulatory approval, and commercial partnerships."
    },
    {
      question: "What is the timeline for regulatory approval?",
      answer: "We've completed the FDA pre-submission process for our respiratory wearable in January 2024, with positive feedback. We expect to submit for FDA De-Novo approval in Q4 2025."
    },
    {
      question: "What is the competitive landscape for Large Biosignal Models?",
      answer: "Senti has developed the world's first Large Biosignal Model. Current competitors use application-specific AI models that cannot be generalized across different biosignal types. Our 2TB proprietary dataset gives us a significant advantage in training and refining our model."
    },
    {
      question: "What is the revenue model?",
      answer: "We operate on a model-as-a-service basis, charging medical device manufacturers a per-use fee that typically amounts to approximately 10% of their end-user pricing. This creates a recurring revenue stream while providing partners with a cost-effective AI solution."
    },
    {
      question: "What are the exit opportunities?",
      answer: "As we establish our LBM as the industry standard for medical device AI, potential exit opportunities include acquisition by major healthcare or tech companies, or an IPO as the company scales across multiple clinical applications."
    },
    {
      question: "How does the Large Biosignal Model work?",
      answer: "Our LBM uses a breakthrough neural network architecture known as the 'decomposer network.' This deep learning system is specifically designed to separate, identify, and enhance key diagnostic components of biosignals, even in noisy real-world environments. Unlike conventional deep learning approaches that rely on fixed tokenization (which works well for text but not for continuous, complex biosignals), the decomposer network learns its own structure, making it uniquely capable of extracting clear and actionable biomarkers from raw signal data."
    },
    {
      question: "What strategic partnerships are in place?",
      answer: "We have established partnerships with several medical device companies, including Deep Arc (for arthritis detection) and Bitbaby (for fetal movement and wellbeing monitoring). These companies are actively collecting data and working towards integrating Senti's LBM into their products. We're continually expanding our partnership network."
    },
    {
      question: "What intellectual property protection does Senti have?",
      answer: "Senti has patents approved and pending in the respiratory diagnostics space. Our proprietary dataset and model architecture provide significant barriers to entry for potential competitors. The regulatory approval process for medical devices also provides a moat once our partners' devices are approved with our LBM technology."
    }
  ];

  return (
    <div className="space-y-8">
      <div className="bg-white p-8 rounded-xl shadow-md">
        <h3 className="text-2xl font-bold text-primary mb-8">Frequently Asked Questions</h3>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex justify-between items-center p-4 text-left bg-lightgray hover:bg-gray-200 transition-colors"
                onClick={() => toggleFaq(index)}
              >
                <span className="font-semibold text-primary">{faq.question}</span>
                {expandedFaqs.includes(index) ? (
                  <ChevronUp className="h-5 w-5 text-primary flex-shrink-0" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-primary flex-shrink-0" />
                )}
              </button>
              
              {expandedFaqs.includes(index) && (
                <div className="p-4 bg-white">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white p-8 rounded-xl shadow-md">
        <h3 className="text-2xl font-bold text-primary mb-6">Have More Questions?</h3>
        <p className="text-gray-700 mb-6">
          If you're a qualified investor interested in learning more about Senti's funding round, 
          technology, or business model, we'd be happy to provide more detailed information.
        </p>
        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
          <a href="/contact" className="bg-primary text-white px-6 py-3 rounded-md font-medium hover:bg-secondary transition-colors inline-block text-center">
            Request Investor Deck
          </a>
          <a href="/contact" className="border-2 border-primary text-primary px-6 py-3 rounded-md font-medium hover:bg-accent hover:border-accent transition-colors inline-block text-center">
            Schedule a Call
          </a>
        </div>
      </div>
    </div>
  );
};

export default FaqSection;